/*
 * ConnectionManager Messages
 *
 * This contains all the text for the ConnectionManager.
 */
import { defineMessages } from 'react-intl';

const scope = 'coursewareItem';

export default defineMessages({
  defaultError: {
    id: `${scope}.error.default`,
    defaultMessage: 'There was a technical problem checking your answer. If the issue keeps occurring, try refreshing your browser window.',
  },
  evaluationError: {
    id: `${scope}.error.evaluation`,
    defaultMessage: `You have started to work on an assignment in another window.
    You are not permitted to have two assignment windows open at the same time.
    Please note that your answers may not be saved properly if you are using two windows to work on your assignment.
    `,
  },
});
